import { Radio } from '@mantine/core';
import classes from './Radio.module.css';

export const RadioConfig = Radio.extend({
  classNames: {
    radio: classes.radio,
  },
});
